import { deletePanelVents } from '../../panels/helpers';
import { Island } from '../island.class';
import { Panel } from '../../panels/panel.class';
import { ReferenceMap } from '../../shared.types';

export type DeleteIslandVentsParams = {
	island: Island;
	refMap: ReferenceMap;
}
export const deleteIslandVents = (params: DeleteIslandVentsParams): number => {
	// console.log('islands:helpers:-> deleteIslandVents', params);
	const { island } = params;
	let count = 0;

	if (!island.panels) {
		// console.log('islands:helpers:<- deleteIslandVents', 'short circuit: no islands found.');
		return count;
	}

	if (island.hasVents) {
		island.panels.children.forEach((panel) => {
			count += deletePanelVents({ panel: panel as Panel, refMap: params.refMap });
		});
	}

	if (count !== 0) console.info('%cVents were removed from the island\'s panels.', 'color:green;font-weight:bold;border:1px solid black;padding:5px;');
	// console.log('islands:helpers:<- deleteIslandVents', { count });
	return count;
};
